
export const ConsignmentServiceTypes = [
    {
        id: 0,
        name: 'Third Party'
    },
    {
        id: 1,
        name: 'Collection Carriage Forward'
    },
    {
        id: 2,
        name: 'International'
    },
    {
        id: 3,
        name: 'Overnight'
    },
    {
        id: 4,
        name: 'Same Day'
    }
];

export const CONSIGNMENT_SERVICE_TYPE = {
    THIRD_PARTY: {
        id: 0,
        name: 'Third Party'
    },
    COLLECTION_CARRIAGE_FORWARD: {
        id: 1,
        name: 'Collection Carriage Forward'
    },
    INTERNATIONAL: {
        id: 2,
        name: 'International'
    },
    OVERNIGHT: {
        id: 3,
        name: 'Overnight'
    },
    SAMEDAY: {
        id: 4,
        name: 'Same Day'
    }
};
